import { Box, Container, Typography } from "@mui/material";
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';          
import YouTubeIcon from '@mui/icons-material/YouTube';

function Footer() {
  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: "#1a1a1a",
        color: "white",
        pt: 8,
        pb: 3,
      }}
    >
      <Container>
        {/* Main Footer Content */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(4, 1fr)",
            },
            gap: 6,
            mb: 6,
          }}
        >
          {/* About Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "20px",
                fontWeight: 700,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              TVFM
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: 1.8,
                color: "rgba(255,255,255,0.7)",
                mb: 3,
              }}
            >
              Premium grooming products and professional barber services for the modern gentleman.
            </Typography>
            {/* Social Icons */}
            <Box sx={{ display: "flex", gap: 2 }}>
  {[
    { Icon: FacebookIcon, label: "Facebook" },
    { Icon: InstagramIcon, label: "Instagram" },
    { Icon: TwitterIcon, label: "Twitter" },           
    { Icon: YouTubeIcon, label: "YouTube" },
  ].map(({ Icon, label }) => (
    <Box
      key={label}
      component="a"
      href={`https://${label.toLowerCase()}.com/yourprofile`} 
      target="_blank"
      rel="noopener"
      sx={{
        width: 40,
        height: 40,
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: "50%",           
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        color: "white",
        "&:hover": {
          bgcolor: "white",
          color: "#222",
          borderColor: "white",
        },
      }}
    >
      <Icon sx={{ fontSize: 20 }} />
    </Box>
  ))}
            </Box>
          </Box>

          {/* Quick Links Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              QUICK LINKS
            </Typography>
            {["Home", "Shop", "About Us", "Contact", "Blog"].map((link) => (
              <Typography
                key={link}
                sx={{
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.7)",
                  mb: 2,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "white",
                    paddingLeft: "8px",
                  },
                }}
              >
                {link}
              </Typography>
            ))}
          </Box>

          {/* Categories Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              CATEGORIES
            </Typography>
            {["Trimmer", "Hair Care", "Skin Care", "Perfume", "Tools"].map((category) => (
              <Typography
                key={category}
                sx={{
                  fontSize: "14px",
                  color: "rgba(255,255,255,0.7)",
                  mb: 2,
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    color: "white",
                    paddingLeft: "8px",
                  },
                }}
              >
                {category}
              </Typography>
            ))}
          </Box>

          {/* Contact Column */}
          <Box>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: 600,
                mb: 3,
                letterSpacing: "1px",
              }}
            >
              CONTACT US
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
                mb: 2,
                lineHeight: 1.8,
              }}
            >
              No-2/S1, VGN Platina,<br />
               Thiruverkadu Road,Ayapakkam, Chennai – 600077<br />
              India
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
                mb: 1,
              }}
            >
              Phone: +91 9940658115
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                color: "rgba(255,255,255,0.7)",
              }}
            >
              Email: tvfmsynergy@gmail.com
            </Typography>
          </Box>
        </Box>

        {/* Divider */}
        <Box
          sx={{
            height: "1px",
            bgcolor: "rgba(255,255,255,0.1)",
            mb: 4,
          }}
        />

        {/* Bottom Footer */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              fontSize: "13px",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            © 2025 TVFM Synergy LLP - Designed By Digital Triumph Private Limited.
          </Typography>
          {/* <Box sx={{ display: "flex", gap: 4 }}>
            {["Privacy Policy", "Terms & Conditions", "Shipping Policy"].map((item) => (
              <Typography
                key={item}
                sx={{
                  fontSize: "13px",
                  color: "rgba(255,255,255,0.5)",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  ...rubikfont,
                  "&:hover": {
                    color: "white",
                  },
                }}
              >
                {item}
              </Typography>
            ))}
          </Box> */}
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;


